import React, { useMemo } from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { useUserStripeData } from "hooks/useUserStripeData";
import { TooltipBaseV2, TooltipProps } from "../TooltipBaseV2";
import { GatedContentStatus } from "store/stripeConnectAccount/types";

interface GatedContentDisabledTooltipProps extends Partial<TooltipProps> {
    gatedContentStatus: GatedContentStatus;
    override?: boolean;
    overrideKey?: string;
    children?: JSX.Element;
}

export const GatedContentDisabledTooltip = ({
    gatedContentStatus,
    children,
    style,
    labelOrientation,
    override,
    overrideKey = ""
}: GatedContentDisabledTooltipProps) => {
    const {
        accountData: {
            link: { href, target }
        }
    } = useUserStripeData({
        includeProducts: false,
        requestImmediately: true
    });

    const content = useMemo<string>(() => {
        if (override) return overrideKey;

        switch (gatedContentStatus) {
            case GatedContentStatus.READY:
                return "video-player-settings:connect-stripe";
            case GatedContentStatus.STRIPE_ACCOUNT_UNVERIFIED:
            default:
                return "video-player-settings:verify-stripe";
        }
    }, [gatedContentStatus, override, overrideKey]);

    return (
        <TooltipBaseV2
            type="info"
            show={override || gatedContentStatus !== GatedContentStatus.READY}
            body={
                <Trans
                    i18nKey={content}
                    components={{
                        link1: (
                            <Link
                                to={href}
                                target={target}
                                style={{
                                    color: "#138F99",
                                    textDecoration: "none"
                                }}
                                title="Gated Content - Stripe Connect Account"
                            />
                        )
                    }}
                />
            }
            style={style}
            labelOrientation={labelOrientation}
        >
            {children}
        </TooltipBaseV2>
    );
};
